document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

let mybutton = document.getElementById("btn-back-to-top");

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 20 ||
    document.documentElement.scrollTop > 20
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

mybutton.addEventListener("click", backToTop);

function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// Togle mobile nav
var mobileNavToggler = document.getElementById('mobileNavToggler')
var menuOffcanvas = document.getElementById('navbarNav')
menuOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
  mobileNavToggler.classList.add("open");
  mobileNavToggler.classList.remove("close");
})
menuOffcanvas.addEventListener('shown.bs.offcanvas', function () {
  mobileNavToggler.classList.add("close");
  mobileNavToggler.classList.remove("open");
})

var mbNavacc = document.getElementsByClassName('menu-item-has-children');
var mbNavTG = document.getElementsByClassName('dropdown-toggler-icon');

function hasClass(elem, className) {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}

for (i = 0; i < mbNavTG.length; i++) {
  mbNavTG[i].addEventListener('click', toggleItem, false);
}

function toggleItem() {
  var inParent = this.parentNode;
  
  if ( hasClass(inParent, 'children-open')  ) {
    inParent.classList.remove('children-open');
  }
  else{
    inParent.classList.add('children-open');
  }
}

var srcDown = document.getElementById('scrDown');

if (srcDown) {
  function circleTypeScr(){
    const circleType3 = new CircleType(document.getElementById('scr-down-circle'));
    const circleType4 = new CircleType(document.getElementById('scr-down-circle2'));

    circleType3.radius(69).dir(1);
    circleType4.radius(64).dir(-1);
  }

  circleTypeScr();
}

// Slider HP
var headerSlider = document.getElementById("headerSlider");

if (headerSlider) {
    document.addEventListener( 'DOMContentLoaded', function() {
    var headerSliderSplide = new Splide( headerSlider, {
      arrows: false,
      pagination : false,
      type: 'fade',
      autoplay: true,
      interval: 5000,
      rewind: true,
      pauseOnHover: false,
    } );


    var thumbnails = new Splide( '#thumbnail-slider', {
      rewind          : false,
      fixedWidth      : 300,
      isNavigation    : true,
      gap             : 32,
      pagination      : false,
      arrows          : false,
      wheel           : false,
      drag            : false,
      breakpoints: {
        992: {
          gap         : 16,
        },
      }
    } );

    headerSliderSplide.sync( thumbnails );
    headerSliderSplide.mount();
    thumbnails.mount();
  } );
}

// model gallery slider
var modleGallerySlider = document.getElementById("modelGallerySlider");

if (modleGallerySlider) {
    document.addEventListener( 'DOMContentLoaded', function() {
    var mgsSplide = new Splide( modleGallerySlider, {
      arrows: false,
      pagination : true,
      type: 'fade'
    } );

    mgsSplide.mount();
  } );
}

// cfmoto slider
var cfmotoSlider = document.getElementById("cfmotoSlider");
if (cfmotoSlider) {
    document.addEventListener( 'DOMContentLoaded', function() {
    new Splide( cfmotoSlider, {
        autoplay: 'pause',
        intersection: {
          inView: {
            autoplay: true,
          },
          outView: {
            autoplay: false,
          },
        },
        pauseOnHover: false,
        interval: 2500,
        pagination: false,
        arrows: false,
        type: 'loop',
        perPage: 2,
        perMove: 1,
        breakpoints: {
        767: {
          perPage: 1,
          perMove: 1,
          pagination: true,
        },
      }
    } ).mount( window.splide.Extensions );

  } );
}

// prislusenstvi slider
var acsrSlider = document.getElementById("acsrslider");

if (acsrSlider) {
    document.addEventListener( 'DOMContentLoaded', function() {
    var acsrSplide = new Splide( acsrSlider, {
      pagination : true,
      type: 'fade',
    } );

    acsrSplide.mount();
  } );
}

// Background images to right edge and responsive
function postImageRsize(){
  var fullWidthPosts = document.getElementsByClassName("bg-image-large");
  for (var i = 0; i < fullWidthPosts.length; i++) {

    var currentPost = fullWidthPosts.item(i);
    var getStyle = window.getComputedStyle(currentPost);

    var image = currentPost.getElementsByClassName("image");


    if(parseInt(getStyle.width,10) >= 720) {
      image[0].style.width = (parseInt(getStyle.width,10) * 0.5833333 + parseInt(getStyle.marginLeft,10)) +'px';
    }
    else{
      image[0].style.width = '100%';
    }
  }
}

function postImageRsize(){
  var fullWidthPosts = document.getElementsByClassName("bg-image-small");
  for (var i = 0; i < fullWidthPosts.length; i++) {

    var currentPost = fullWidthPosts.item(i);
    var getStyle = window.getComputedStyle(currentPost);

    var image = currentPost.getElementsByClassName("image");


    if(parseInt(getStyle.width,10) >= 720) {
      image[0].style.width = (parseInt(getStyle.width,10) * 0.4166667 + parseInt(getStyle.marginLeft,10)) +'px';
    }
    else{
      image[0].style.width = '100%';
    }
  }
}

function postSliderRsize(){
  var postImageSlider = document.getElementsByClassName("model-detail-slider");
  for (var i = 0; i < postImageSlider.length; i++) {

    var currentSlider = postImageSlider.item(i);
    var contStyle = window.getComputedStyle(currentSlider);

    var eleImage = currentSlider.getElementsByClassName("image");

    if(parseInt(contStyle.width,10) >= 720) {
      eleImage[0].style.width = (parseInt(contStyle.width,10) * 0.4166667 + parseInt(contStyle.marginRight,10)) +'px';
    }
    else{
      eleImage[0].style.width = '100%';
    }
  }
}

function setImageForCard(){
  var vwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  var cardImage = document.getElementsByClassName("card-image");
  
  if(vwidth > 767) {
    for (var i = 0; i < cardImage.length; i++) {
      currentCardImage = cardImage.item(i);

      imgUrlValue = currentCardImage.getAttribute('data-image');

      currentCardImage.style.backgroundImage = 'url('+imgUrlValue+')';

      if( currentCardImage.getElementsByTagName('img').length > 0) {
        var imgTag = document.querySelector( '.bg-image' );
        imgTag.parentNode.removeChild( imgTag );
      }
    }
  }
  else{
    for (var i = 0; i < cardImage.length; i++) {
      currentCardImage = cardImage.item(i);

      imgUrlValue = currentCardImage.getAttribute('data-image');

      console.log(imgUrlValue);

      if( currentCardImage.getElementsByTagName('img').length == 0) {
        elem = document.createElement("img");

        currentCardImage.appendChild(elem);

        elem.src = imgUrlValue;
        elem.className = "bg-image";
      }

      currentCardImage.style.backgroundImage = "none";
    }
  }
}

function setImageForSlider(){
  var svwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  var sliderImage = document.getElementsByClassName("md-slider-image");
  
  if(svwidth > 767) {
    for (var i = 0; i < sliderImage.length; i++) {
      currentSliderImage = sliderImage.item(i);

      siUrlValue = currentSliderImage.getAttribute('data-image');

      console.log(siUrlValue);

      currentSliderImage.style.backgroundImage = 'url('+siUrlValue+')';

      if( currentSliderImage.getElementsByTagName('img').length > 0) {
        var imgTag = document.querySelector( '.bg-image' );
        imgTag.parentNode.removeChild( imgTag );
      }
    }
  }
  else{
    for (var i = 0; i < sliderImage.length; i++) {
      currentSliderImage = sliderImage.item(i);

      siUrlValue = currentSliderImage.getAttribute('data-image');

      console.log(siUrlValue);

      if( currentSliderImage.getElementsByTagName('img').length == 0) {
        elem = document.createElement("img");

        currentSliderImage.appendChild(elem);

        elem.src = siUrlValue;
        elem.className = "bg-image";
      }

      currentSliderImage.style.backgroundImage = "none";
    }
  }
}

postImageRsize();
postSliderRsize()
setImageForCard();
setImageForSlider();

var mapLoaded = document.getElementById("map");

(function($) {

  $('.model-gallery, .wp-block-image').photobox('a',{ zoomable:false });

  var ajaxurl = theme_info.php_ajaxurl;

  $( document ).ready(function() {

    $('a[target="_blank"]').addClass(function(){
      if($(this).children().length==0)
        return 'external_link';
    })

    $('.prodejci-header').click(function(){
      $(this).find('.content').hide();
    }); 

    $('div').on('click', '.cat-list_item', function(e) {

      var currentLi = $(this).data('slug');
      var parentLi = $('.modely-filter a[data-slug=' + currentLi + ']').parent();

      if (! $(this).closest(".list-toggler").length) {

        e.preventDefault();
        $('.cat-list_item').removeClass('is-checked');
        $('.modely-filter a[data-slug=' + currentLi + ']').addClass('is-checked');

        var is_type = $(this).data('t-type');

        $.ajax({
          type: 'POST',
          url: ajaxurl,
          dataType: 'html',
          data: {
            action: 'filter_projects',
            category: $(this).data('slug'),
            paged_nuber: $(this).data('page'),
            t_type: $(this).data('t-type'),
            tsj: $(this).data('tsj'),
          },
          beforeSend: function() {
            if ( is_type != 'prodejci_categories' ) {
              $([document.documentElement, document.body]).animate({
                  scrollTop: $("#modelyFilter").offset().top
              }, 100);
            }

            $('.ajax-loader').css('display', 'flex');
           },
          success: function(res) {
            $('#ajax-list').html(res);
            if (mapLoaded) {
              initMap();
            }
            $('.ajax-loader').css('display', 'none');
          }
        })

        $('.modely-filter li').removeClass('list-toggler');
        $('.modely-filter a[data-slug=' + currentLi + ']').parent().addClass('list-toggler');
        $('.modely-filter li').not(parentLi).hide();
      }
    });

    $('div').on('click', '.list-toggler', function(e) {
      e.preventDefault();
      $(this).parent().find('li').not(this).toggle();
    });

  });

  $( window ).resize(function() {
    circleTypeScr();
    postImageRsize();
    postSliderRsize()
    setImageForCard();
    setImageForSlider()
  });

})( jQuery ); 

//Mapa

function initMap() {

  var markers = prodejci_markers;

  var mapOptions = {
      center: new google.maps.LatLng(markers[0].lat, markers[0].lng),
      zoom: 8,
      mapTypeId: google.maps.MapTypeId.ROADMAP
  };
  var infoWindow = new google.maps.InfoWindow();
  var latlngbounds = new google.maps.LatLngBounds();
  var map = new google.maps.Map(document.getElementById("map"), mapOptions);

  var infowindow = new google.maps.InfoWindow()

  for (var i = 0; i < markers.length; i++) {
      var data = markers[i];

      var myLatlng = new google.maps.LatLng(data.lat, data.lng);
      var marker = new google.maps.Marker({
          position: myLatlng,
          title: decodeHtml(data.title),
          map: map
      });

      var markerLabel =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<h4 id="firstHeading" class="firstHeading">'+data.title+'</h4>' +
        '<div id="bodyContent">' +
        "<p>"+data.address+"</p>" +
        '<p><a href="'+data.permalink+'">' +
        "Detail prodejny</a>"+
        "</div>" +
        "</div>";

      google.maps.event.addListener(marker,'click', (function(marker,markerLabel,infowindow){ 
          return function() {
             infowindow.setContent(markerLabel);
             infowindow.open(map,marker);
          };
      })(marker,markerLabel,infowindow));
      
      latlngbounds.extend(marker.position);
  }

  var bounds = new google.maps.LatLngBounds();
  map.setCenter(latlngbounds.getCenter());
  map.fitBounds(latlngbounds);
}

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

